﻿import { Component, OnInit } from '@angular/core';
import { CONFIG } from '../../core/config';
import { LanguageService } from '../../core/language/language.service';


export class TitleLabels {
    NaslovBrojPitanja: string;
    NaslovZaVrijemeOdgovora: string;
    NaslovZaBrojPitanjaPoPolu: string;
    NaslovZaBrojPitanjaPoKategoriji: string;
    NaslovZaBrojPitanjaPoStarosnimGrupama: string;
    NaslovZaOdgovorenaINeodgovorenaPitanja: string;
    NaslovZaProsjecnoVrijemeOdgovora: string;
}

export class NumberOfQuestionsAndAnswers {
    numberOfQuestions: number;
    numberOfAnswers: number;
}

export class ListByAnswerTime {
    id: number;
    questionsList: QuestionsModel[] = [];
}

export class QuestionsModel {
    id: number;
    answerTime: number;
    answerTimeFormatted: string;
}

export class NumberOfQuestionsByGender {
    sexId: number;
    sexName: string;
    number: number;
}

export class NumberOfQuestionsBySensitiveCategory {
    sensitiveCategoryId: number;
    sensitiveCategoryName: string;
    number: number;
}

export class NumberOfQuestionsByYearGroup {
    number: number;
    numberYear: number;
}

export class NumberOfAnsweredAndNotAnsweredQuestions {
    id: number;
    name: string;
    numberOfQuestions: number;
    numberOfAnswered: number;
    numberOfNotAnswered: number;
}

export class ListAverageAnswerTime {
    id: number;
    name: string;
    averageAnswerTime: number;
    averageAnswerTimeFormatted: string;
}
@Component({
    selector: 'app-question-statistic',
    templateUrl: `./questions-statistic.component.html`,
    styles: []
})

export class QuestionStatisticComponent implements OnInit {

    kategorije = [
        { vrednost: CONFIG.categoriesDropdownEnuum.mayor, oznaka: this._languageService.translateByMunicipalityId('gradonacelnik') },
        { vrednost: CONFIG.categoriesDropdownEnuum.council, oznaka: this._languageService.translateByMunicipalityId('odbornici') },
        { vrednost: CONFIG.categoriesDropdownEnuum.sector, oznaka: this._languageService.instant('organizacione_jedinice') }
    ];

    public izabranaKategorija: number;

    private numberOfQuestionsAnswersList: NumberOfQuestionsAndAnswers;
    private listByAnswerTime: ListByAnswerTime;
    private numberOfQuestionsByGender: NumberOfQuestionsByGender[] = [];
    private numberOfQuestionsBySensitiveCategory: NumberOfQuestionsBySensitiveCategory[] = [];
    private numberOfQuestionsByYearGroup: NumberOfQuestionsByYearGroup[] = [];
    private numberOfAnsweredAndNotAnsweredQuestions: NumberOfAnsweredAndNotAnsweredQuestions[] = [];
    private listAverageAnswerTime: ListAverageAnswerTime[] = [];
    public titleLabels: TitleLabels;

    constructor(private _languageService: LanguageService) {

        this.titleLabels = new TitleLabels();
        
        }

    ngOnInit() {
        this.izabranaKategorija = CONFIG.categoriesDropdownEnuum.mayor;
        this.titleLabels.NaslovBrojPitanja = this._languageService.translateByMunicipalityId('broj_pitanja_odgovora_gradonacelnik');
        this.titleLabels.NaslovZaVrijemeOdgovora = this._languageService.translateByMunicipalityId('vrijeme_odgovora_gradonacelnik');
        this.titleLabels.NaslovZaProsjecnoVrijemeOdgovora = this._languageService.translateByMunicipalityId('prosjecno_vrijeme_odgovora_gradonacelnik');
        
        
    }


    getQuestionsAnswersList(data: NumberOfQuestionsAndAnswers) {
        this.numberOfQuestionsAnswersList = data;
    }
    getListByAnswerTime(data: ListByAnswerTime) {
        this.listByAnswerTime = data;
    }
    getNumberOfQuestionsByGender(data: NumberOfQuestionsByGender[]) {
        this.numberOfQuestionsByGender = data;
    }
    getNumberOfQuestionsBySensitiveCategory(data: NumberOfQuestionsBySensitiveCategory[]) {
        this.numberOfQuestionsBySensitiveCategory = data;
    }
    getNumberOfQuestionsByYearGroup(data: NumberOfQuestionsByYearGroup[]) {
        this.numberOfQuestionsByYearGroup = data;
    }
    getNumberOfAnsweredAndNotAnsweredQuestions(data: NumberOfAnsweredAndNotAnsweredQuestions[]) {
        this.numberOfAnsweredAndNotAnsweredQuestions = data;
    }
    getListAverageAnswerTime(data: ListAverageAnswerTime[]) {
       
        this.listAverageAnswerTime = data;
    }
    getTitleLabels(data: TitleLabels) {
        this.titleLabels = data;
    }
    onCategoryChange(id: number) {
        if (id == CONFIG.categoriesDropdownEnuum.mayor) {
            this.titleLabels.NaslovBrojPitanja = this._languageService.translateByMunicipalityId('broj_pitanja_odgovora_gradonacelnik');
            this.titleLabels.NaslovZaVrijemeOdgovora = this._languageService.translateByMunicipalityId('vrijeme_odgovora_gradonacelnik');
            this.titleLabels.NaslovZaProsjecnoVrijemeOdgovora = this._languageService.translateByMunicipalityId('prosjecno_vrijeme_odgovora_gradonacelnik');
        } else if (id == CONFIG.categoriesDropdownEnuum.council) {
            this.titleLabels.NaslovBrojPitanja = this._languageService.translateByMunicipalityId('broj_pitanja_odgovora_po_clanu');
            this.titleLabels.NaslovZaVrijemeOdgovora = this._languageService.translateByMunicipalityId('vrijeme_odgovora_po_clanu');
            this.titleLabels.NaslovZaProsjecnoVrijemeOdgovora = this._languageService.translateByMunicipalityId('prosjecno_vrijeme_odgovora_po_vijecnicima');
        } else {
            this.titleLabels.NaslovBrojPitanja = this._languageService.translateByMunicipalityId('broj_pitanja_odgovora_org');
            this.titleLabels.NaslovZaVrijemeOdgovora = this._languageService.translateByMunicipalityId('vrijeme_odgovora_org');
            this.titleLabels.NaslovZaProsjecnoVrijemeOdgovora = this._languageService.translateByMunicipalityId('prosjecno_vrijeme_odgovora_org');
        }
    }
   
}